import * as THREE from 'three';
import BasicObject from './BasicObject';
import { LineIntersType, RoomType } from '../types';

interface RoomProps {
  dottedName: string;
  contour: Array<THREE.Vector3>;
  drainFunnelPosition?: THREE.Vector3;
  drainFunnelLine?: LineIntersType;
}
export class Room extends BasicObject implements RoomType {
  contour: Array<THREE.Vector3>;
  material: THREE.MeshBasicMaterial = new THREE.MeshBasicMaterial({
    color: '#ff00ff',
    // wireframe: true,
  });
  drainFunnelPosition?: THREE.Vector3;
  drainFunnelLine?: LineIntersType;
  linesInters: Array<LineIntersType> = [];
  constructor({ contour, drainFunnelPosition, drainFunnelLine, dottedName }: RoomProps) {
    super();
    this.name = dottedName;
    this.type = 'room';
    this.contour = contour;
    this.drainFunnelPosition = drainFunnelPosition;
    this.drainFunnelLine = drainFunnelLine;

    this.createLinesInters();
    this.buildGeometry();
  }

  buildGeometry() {
    super.buildGeometry();
    this.geometry = new THREE.Geometry();
    for (let i = 0; i < this.contour.length; i++) {
      const point = this.contour[i].clone();
      this.geometry.vertices.push(point);
    }
    const points2d: Array<THREE.Vector2> = this.contour.map(
      point => new THREE.Vector2(point.x, point.z)
    );

    const triangles = THREE.ShapeUtils.triangulateShape(points2d, []);
    for (let i = 0; i < triangles.length; i++) {
      this.geometry.faces.push(new THREE.Face3(triangles[i][0], triangles[i][1], triangles[i][2]));
    }
  }
  getPlanesZeroIntersected(): Array<THREE.Mesh> {
    const res: Array<THREE.Mesh> = [];
    if (this.drainFunnelLine) {
      const _contour = this.contour.map(v => v.clone().setY(0));
      for (let i = 0; i < _contour.length; i++) {
        const p1 = _contour[i];
        let p2, p3, p4;
        if (i < _contour.length - 1) {
          p2 = _contour[i + 1];
        } else {
          p2 = _contour[0];
        }

        if (p1.distanceTo(this.drainFunnelLine.start) < p1.distanceTo(this.drainFunnelLine.end)) {
          p3 = this.drainFunnelLine.start.clone();
        } else {
          p3 = this.drainFunnelLine.end.clone();
        }

        if (p2.distanceTo(this.drainFunnelLine.start) < p2.distanceTo(this.drainFunnelLine.end)) {
          p4 = this.drainFunnelLine.start.clone();
        } else {
          p4 = this.drainFunnelLine.end.clone();
        }

        if (p3.equals(p4)) {
          const triangle = this.createTriangle(p1, p2, p3);
          res.push(triangle);
        } else {
          const plane = this.createPlane(p1, p2, p3, p4);
          res.push(plane);
        }
      }
    } //
    else if (this.drainFunnelPosition) {
      const _contour = this.contour.map(v => v.clone().setY(0));
      for (let i = 0; i < _contour.length; i++) {
        const p1 = _contour[i];
        let p2;
        const p3 = this.drainFunnelPosition.clone();

        if (i < _contour.length - 1) {
          p2 = _contour[i + 1];
        } else {
          p2 = _contour[0];
        }
        const triangle = this.createTriangle(p1, p2, p3);
        res.push(triangle);
      }
    }
    return res;
  }

  removeMesh() {
    super.removeMesh(this);
  }
  private createTriangle(v1: THREE.Vector3, v2: THREE.Vector3, v3: THREE.Vector3): THREE.Mesh {
    const geom = new THREE.Geometry();

    const triangle = new THREE.Triangle(v1, v2, v3);
    // const normal = new THREE.Vector3();
    // triangle.getNormal(normal);
    geom.vertices.push(triangle.a);
    geom.vertices.push(triangle.b);
    geom.vertices.push(triangle.c);
    geom.faces.push(new THREE.Face3(1, 0, 2));
    geom.computeFaceNormals();
    return new THREE.Mesh(
      geom,
      new THREE.MeshBasicMaterial({
        color: Math.random() * 0xffffff,
        // wireframe: false,
        side: THREE.DoubleSide,
      })
    );
  }
  private createPlane(
    v0: THREE.Vector3,
    v1: THREE.Vector3,
    v2: THREE.Vector3,
    v3: THREE.Vector3
  ): THREE.Mesh {
    const geom = new THREE.Geometry();
    geom.vertices.push(v0);
    geom.vertices.push(v1);
    geom.vertices.push(v2);
    geom.vertices.push(v3);

    geom.faces.push(new THREE.Face3(2, 1, 0), new THREE.Face3(2, 3, 1));
    geom.computeFaceNormals();
    return new THREE.Mesh(
      geom,
      new THREE.MeshBasicMaterial({
        color: Math.random() * 0xffffff,
        // wireframe: false,
        side: THREE.DoubleSide,
      })
    );
  }
  private createLinesInters() {
    if (this.contour) {
      for (let i = 0; i < this.contour.length; i++) {
        if (i < this.contour.length - 1) {
          this.linesInters.push({
            start: this.contour[i].clone(),
            end: this.contour[i + 1].clone(),
          });
        } else {
          this.linesInters.push({
            start: this.contour[i].clone(),
            end: this.contour[0].clone(),
          });
        }
      }
    }
  }
}
